import { render, staticRenderFns } from "./veBaseStudentPhoto.vue?vue&type=template&id=07867b94&scoped=true"
import script from "./veBaseStudentPhoto.vue?vue&type=script&lang=js"
export * from "./veBaseStudentPhoto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07867b94",
  null
  
)

export default component.exports